export default "__VITE_ASSET__CO7WM6p3__"